// SCREENING BILLING PURCHASES ********************************************************************
// pathname: /v1/screening/billing/purchases
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi/useSwrMutationApi';
import type { ApiRequestBody, ApiOkResponse } from '@type/api/apiUtilityFn';

type PurchaseRequestBody = ApiRequestBody<'/v1/screening/billing/purchases', 'post'>;
type PurchaseResponse = ApiOkResponse<'/v1/screening/billing/purchases', 'post'>;

interface UseSwrBestieScreeningActivateProps {
  onSuccess?: (response: PurchaseResponse) => void | Promise<void>;
  onError?: (err: unknown) => void;
}

/**
 * @description Hook for purchasing a screening package via the screening billing API.
 * - `onSuccess`: Optional callback to execute on success.
 * - `onError`: Optional callback to execute on error.
 */
export const useSwrBestieScreeningActivate = (props?: UseSwrBestieScreeningActivateProps) => {
  const { onSuccess, onError } = props ?? {};

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<PurchaseResponse, PurchaseRequestBody>({
    url: '/v1/screening/billing/purchases',
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess: (response) => { if (onSuccess) { void onSuccess(response); } },
      onError: (err) => { if (onError) onError(err); },
    },
    toastsOptions: {
      showErrorToast: true,
      showSuccessToast: false,
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
